import { makeApi, makeErrors } from "@zodios/core";
import { z } from "zod";

export const CopilotStatus = z.object({
  hasApiKey: z.boolean(),
});

export type CopilotStatus = z.infer<typeof CopilotStatus>;

export const UserOpenAIApiKey = z.object({
  state: z.enum(["valid", "invalid", "not-set"]),
  // e.g. "sk-****-abcd"
  maskedValue: z.string().nullable(),
});

export type UserOpenAIApiKey = z.infer<typeof UserOpenAIApiKey>;

// todo: put this somewhere else...
const requiresOrgAdminErrors = makeErrors([
  {
    status: 403,
    schema: z.object({
      code: z.literal("requires-admin"),
      message: z.string(),
    }),
  },
]);

export const apiKeyApi = makeApi([
  {
    method: "get",
    path: "/copilot/status",
    alias: "getCopilotStatus",
    response: CopilotStatus,
    errors: [],
  },
  {
    method: "get",
    path: "/copilot/keys/openai",
    alias: "getOpenAIApiKey",
    response: UserOpenAIApiKey,
    errors: [...requiresOrgAdminErrors],
  },
  {
    method: "put",
    path: "/copilot/keys/openai",
    alias: "setOpenAIApiKey",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: z.object({
          // setting to null removes the key.
          value: z.string().nullable(),
        }),
      },
    ],
    response: z.void(),
    status: 204,
    errors: [...requiresOrgAdminErrors],
  },
]);
